function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.08889 3.34243C8.08889 3.45269 7.77778 5.69445 6.84444 6.6132C8.08889 1.10526 3.42222 0 3.42222 0C3.42222 0 4.13778 2.75443 3.11111 4.07744C3.04889 2.57068 2.33333 1.65193 2.33333 1.65193C1.80444 4.37144 0 6.72346 0 8.48746C0 11.5378 2.08444 14 4.66667 14C7.24889 14 9.02222 11.7895 9.33333 8.48746C9.33333 6.28245 9.33333 4.78947 8.08889 3.34243Z",
  fill: "#E53E3E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.22222 10.4474C6.22222 11.4053 5.53778 12.1579 4.66667 12.1579C3.79556 12.1579 3.11111 11.4053 3.11111 10.4474C3.11111 9.48953 4.66667 6.17108 4.66667 6.17108C4.66667 6.17108 6.22222 9.48953 6.22222 10.4474Z",
  fill: "#E53E3E"
});

function SvgHeatMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMeter);
export default __webpack_public_path__ + "static/media/heat-meter.4e5a0543.svg";
export { ForwardRef as ReactComponent };